import { render, staticRenderFns } from "./SectionXidCanDo.vue?vue&type=template&id=3c74f3ab&scoped=true"
import script from "./SectionXidCanDo.vue?vue&type=script&lang=ts"
export * from "./SectionXidCanDo.vue?vue&type=script&lang=ts"
import style0 from "./SectionXidCanDo.vue?vue&type=style&index=0&id=3c74f3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c74f3ab",
  null
  
)

export default component.exports